var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFolder = function SvgFolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 17 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#444",
    strokeMiterlimit: 10,
    strokeWidth: 1.2,
    d: "M15.583 7.792v4.25c0 2.833-.709 3.542-3.542 3.542H4.958c-2.834 0-3.542-.709-3.542-3.542V4.959c0-2.834.708-3.542 3.542-3.542H6.02c1.063 0 1.297.312 1.7.85l1.063 1.417c.269.354.425.566 1.133.566h2.125c2.833 0 3.542.709 3.542 3.542Z"
  })));
};
export default SvgFolder;